// extracted by mini-css-extract-plugin
export default {"content_dt":"Loja_content_dt__21UQn","content_dtfilmes":"Loja_content_dtfilmes__eKj3s","wrapper":"Loja_wrapper__M+7eO"};